import base from '../dr-base'
import drGridLayout from './dr-grid-layout.vue'

const schema = {
  $Type: 'dr-grid-layout',
  name: 'Layout grid',
  group: 'Container widgets',
  icon: 'table',
  ...base,
  properties: {
    ...base.properties,
    Rows: {
      type: 'array',
      items: {
        type: 'object'
      },
      default: [
        {
          $ID: 'row',
          Columns: [
            {
              $ID: 'col',
              Weight: 6,
              Widgets: []
            },
            {
              $ID: 'col2',
              Weight: 6,
              Widgets: []
            }
          ]
        }
      ]
    },
    Fluid: {
      name: 'Fluid',
      type: 'boolean',
      default: false
    }
  }
}

export default {
  schema,
  component: drGridLayout
}
